import styled from 'styled-components';

export const HowItWorksPageContainer = styled.main`
    .cmt-ca-marche {
        padding-bottom: 0;
    }

    .ccm-text {
        margin: 0 0 30px;
    }

    @media screen and (max-width: ${props => props.theme.mobile}) {
        #p-commentcamarche .h1-titre {
            padding: 0 20px;
        }

        .cmt-ca-marche .conteneur-mobile {
            padding-left: 0;
        }

        .help-container {
            margin: 0 -20px;
        }
    }

    .faq-container {
        width: 747px;
        border: 3px solid ${props => props.theme.faqContainerColor};

        .faq-bandeau {
            background: ${props => props.theme.faqContainerColor};
            color: ${props => props.theme.faqContainerTitleColor};
            font-size: 16px;
            text-align: center;
            height: 60px;
            padding: 16px 0;
            font-weight: ${props => props.theme.boldWeight};

            .faq-list-container {
                padding: 0 15px;
            }
        }

        .faq-section {
            padding: 23px 15px 0;
            a {
                text-decoration: none;
            }
        }

        .faq-section .question-comment-ca-marche-page {
            cursor: pointer;
            position: relative;
            padding-right: 30px;
        }

        @media screen and (min-width: ${props => props.theme.medium}) and (max-width: ${props =>
                props.theme.large}) {
            width: 66%;
        }

        @media screen and (max-width: ${props => props.theme.mobile}) {
            width: 100%;
            border: none;
            border-bottom: 3px solid ${props => props.theme.faqContainerColor};
        }
    }
`;



// WEBPACK FOOTER //
// ./src/components/pages/howitworks/HowItWorksPageStyle.js